import React from 'react'
import PropTypes from 'prop-types'

const Svg = ({ style, className }) => (
	<svg
		width="30"
		height="33"
		viewBox="0 0 30 33"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		style={style}
		className={className}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 11.3125C8 10.7602 8.44772 10.3125 9 10.3125H21C21.5523 10.3125 22 10.7602 22 11.3125C22 11.8648 21.5523 12.3125 21 12.3125H9C8.44772 12.3125 8 11.8648 8 11.3125Z"
			fill="#B29EFA"
			className="u-scheme-color"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 16.9375C8 16.3852 8.44772 15.9375 9 15.9375H21C21.5523 15.9375 22 16.3852 22 16.9375C22 17.4898 21.5523 17.9375 21 17.9375H9C8.44772 17.9375 8 17.4898 8 16.9375Z"
			fill="#B29EFA"
			className="u-scheme-color"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 22.5625C8 22.0102 8.44772 21.5625 9 21.5625H15C15.5523 21.5625 16 22.0102 16 22.5625C16 23.1148 15.5523 23.5625 15 23.5625H9C8.44772 23.5625 8 23.1148 8 22.5625Z"
			fill="#B29EFA"
			className="u-scheme-color"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20.8686 2H5C4.44771 2 4 2.44772 4 3V30C4 30.5523 4.44772 31 5 31H25C25.5523 31 26 30.5523 26 30V7.28922C26 6.77579 25.8026 6.28204 25.4485 5.91018L22.3171 2.62096C21.9396 2.22444 21.4161 2 20.8686 2ZM5 0C3.34315 0 2 1.34315 2 3V30C2 31.6569 3.34315 33 5 33H25C26.6569 33 28 31.6569 28 30V7.28922C28 6.26237 27.6051 5.27486 26.8971 4.53114L23.7657 1.24193C23.0107 0.448875 21.9636 0 20.8686 0H5Z"
			fill="#B29EFA"
			className="u-scheme-color"
		/>
	</svg>
)

Svg.propTypes = {
	style: PropTypes.string,
	className: PropTypes.string,
}

Svg.defaultProps = {
	style: null,
	className: null,
}

export default Svg
